import { render, staticRenderFns } from "./WProposalCard.vue?vue&type=template&id=26d232dd&scoped=true&"
import script from "./WProposalCard.vue?vue&type=script&lang=js&"
export * from "./WProposalCard.vue?vue&type=script&lang=js&"
import style0 from "./WProposalCard.vue?vue&type=style&index=0&id=26d232dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d232dd",
  null
  
)

export default component.exports